import type { FC, ReactElement } from 'react';
import { Box, Card, CardContent, Divider, IconButton, Link, Typography } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { LoginJWT } from '@/components/authentication/login/LoginJWT';
import { Status, useLoginContext } from './LoginContext';
import DetermineSignIn from '@/components/authentication/login/DetermineSignIn';
import { useInitialFocusRef } from '@/utils/useInitialFocusRef';
import { retrieveDeviceFlowInfo } from './Device.common';


export const LoginCater: FC<{ CreateAccountLink?: ReactElement, ResetPasswordLink?: ReactElement }> = ({ CreateAccountLink, ResetPasswordLink }) => {
  const { states, dispatch } = useLoginContext()

  const boxRef = useInitialFocusRef()
  const isDeviceFlow = Boolean(retrieveDeviceFlowInfo())
  return (
    <Card role="main">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 4 }} >
        <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 3 }} >
          <div>
            <Typography id="sign-in-title" color="textPrimary" variant="h4"
              gutterBottom
              tabIndex={-1}
              component="h1"
            >
              Sign in
            </Typography>
          </div>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 3, position: 'relative' }} >
          {states.status === Status.Phase1 && states.ssoUsername &&
            <Box sx={{ position: 'absolute', top: -18, right: -8 }}>
              <Typography variant="caption" color="InactiveCaptionText" component="label" 
                id="account-back-label" 
                {...{for:"account-back-btn"}}
                sx={{ cursor: 'pointer' }}
              >
                Use another account
              </Typography>
              <IconButton size="small" id="account-back-btn" aria-labelledby="account-back-label" sx={{ transform: 'scale(0.75)' }}
                onClick={() => dispatch({ type: 'reset' })}
              >
                <EastIcon />
              </IconButton>
            </Box>}
          {  states.status === Status.Phase2 // might seen as redundent, but it keeps ui stable when transit
          || states.status === Status.DetermineSignIn ?
          <DetermineSignIn /> :
          <LoginJWT ssoUsername={states.ssoUsername} /> }
        </Box>
        {((states.status === Status.Phase1 && isDeviceFlow) || window.location.pathname !== '/login') ? null : 
          <Divider sx={{ my: 3 }} />}
        {states.status === Status.DetermineSignIn && window.location.pathname === '/login'
          ? <>
              {!isDeviceFlow && CreateAccountLink}
              <Typography variant="body2" color="textSecondary" >
                <Link
                  component="button"
                  variant="body2"
                  underline="hover"
                  onClick={() => dispatch({ type: 'go_local' })}
                  sx={{ cursor: 'pointer', mt: '-2px' }}
                >
                  Sign in
                </Link>{" "}
                with my OnData administrative account.
              </Typography>
            </> 
          
          : states.status === Status.Phase1 && !isDeviceFlow 
          ? ResetPasswordLink

          : null

        }
      </CardContent>
    </Card>
  );
};
